import { useEffect, useRef, useState } from 'react';

export const usePendo = () => {
  return window.pendo;
};
